
import React from "react";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import AddItemBtn from "Common/Custom/AddItemBtn";
import TeamMemberListTable from './Componates/TeamMemberListTable'

const TeamList = () => {
  return (
    <PageBody
      card={true}
      headerchildren={
        <>
          <HeadingOne>Team Member List</HeadingOne>
          <AddItemBtn url="add-team-member" title="Create" />
        </>
      }
    >
      {/* Table section */}
      <div className="col-12">
        <TeamMemberListTable />
      </div>
    </PageBody>
  );
};

export default TeamList;
